import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo_chico.png'
import _imports_1 from '@/assets/ar.svg'
import _imports_2 from '@/assets/us.svg'


const _hoisted_1 = { class: "relative bg-[#0078ce]" }
const _hoisted_2 = { class: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "relative flex h-16 items-center justify-between" }
const _hoisted_4 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0" }
const _hoisted_5 = { class: "flex items-center gap-2 my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex flex-1 items-center justify-center sm:items-stretch sm:justify-start" }, [
          _createElementVNode("div", { class: "flex shrink-0 items-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "h-12 w-auto"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('es'))),
              class: "hover:opacity-70 transition"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_1,
                class: "h-8"
              }, null, -1)
            ]))]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('en'))),
              class: "hover:opacity-70 transition"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_2,
                class: "h-8"
              }, null, -1)
            ]))])
          ])
        ])
      ])
    ])
  ]))
}